module.exports = __webpack_public_path__ + "img/destination.8ecd6331.svg";